export default __webpack_public_path__ + "static/media/pauseButton.a25af53e.svg";